import { Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { useBookCreate } from '@/module/Author/Book/model/BookQuery';
import { BookSchema, bookSchema, defaultBookValues } from '@/module/Author/Book/model/BookSchema';
import { Book } from '@/module/Author/Book/model/BookTypes';
import { ImportItem } from '@/module/Sync/model/SyncTypes';

import { dangerouslyConvertType, useAppNotification } from '@feature/utils';

import { BookForm } from './BookForm';

interface BookSyncProps {
  onSuccess: (book: Book) => void;
  item: ImportItem;
  onCancel: () => void;
  sourceType: string;
}

function convert(item: ImportItem, sourceType: string): BookSchema {
  return dangerouslyConvertType<BookSchema>({
    ...item,
    bdis: [],
    wosCategories: [],
    wosIndexes: [],

    language: null,
    sourceType,
  });
}

export function BookSync({ onSuccess, item, onCancel, sourceType }: BookSyncProps) {
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = useBookCreate();
  const notification = useAppNotification();

  const onSubmit = (values: BookSchema) => {
    mutate(values, {
      onError: notification.error,
      onSuccess: newBook => {
        notification.success();
        onSuccess(newBook);
      },
    });
  };

  return (
    <>
      <Text>{item.publisherName}</Text>
      <BookForm
        title={t('books.form.title.create')}
        schema={bookSchema}
        defaultValues={defaultBookValues}
        values={convert(item, sourceType)}
        isSubmitting={isPending}
        isError={isError}
        isSuccess={isSuccess}
        onSubmit={onSubmit}
        onCancel={onCancel}
        showWosFields={false}
        showScopusFields={false}
      />
    </>
  );
}
